// Members' workspaces carry no color field (unlike helper summaries), so
// derive a stable hue from the id to keep avatars distinguishable.
// §8.0.5 — palette locked to indigo/violet/teal/cyan/sky/emerald/amber so
// the avatar sits inside the app's cool-neutral system; the previous pink
// (#ec4899) clashed against the slate-950/indigo shell.
export const AVATAR_COLORS = [
  '#6366f1', // mosaic-keep: data (member avatar deterministic hex color)
  '#8b5cf6', // mosaic-keep: data (member avatar deterministic hex color)
  '#14b8a6', // mosaic-keep: data (member avatar deterministic hex color)
  '#06b6d4', // mosaic-keep: data (member avatar deterministic hex color)
  '#0ea5e9', // mosaic-keep: data (member avatar deterministic hex color)
  '#10b981', // mosaic-keep: data (member avatar deterministic hex color)
  '#f59e0b', // mosaic-keep: data (member avatar deterministic hex color)
]

export const colorFor = (id: string): string => {
  let hash = 0
  for (let index = 0; index < id.length; index += 1) hash = (hash * 31 + id.charCodeAt(index)) | 0
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
}

export const getInitials = (name?: string | null): string => {
  if (!name) return '?'
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
